module.exports = __webpack_public_path__ + "static/media/Inter-Regular.f22b8058.ttf";